module.exports = __webpack_public_path__ + "media/react/components/FavouritePlans/SavedSequence/assets/ico-upper-d7a134d33a5038a112a327922a5c8693.svg";